import { httpRequest } from "../../http";
import { EngagementAction } from "@models/engagementAction";
import { EngagementActionSerializer } from "@models/serializers/engagementActionSerializer";

export class CommandListMyActions {
  async run(userId: number): Promise<EngagementAction[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/actions/?assigned_to=${userId}`;
    const response = await httpRequest<any[]>(url, { method: "GET" });
    return new EngagementActionSerializer().deserializeList(response ?? []);
  }
}
